export default __webpack_public_path__ + "static/media/offer2.87dc27b2.jpg";